export default class Store {
    constructor(writable) {
        this._writable = writable;
        this._values = {};
        this._state = {};
    }
    setState(data) {
        const state = this._state;
        for (const key in data) {
            if (state[key]) {
                state[key].set(data[key]);
            }
            else {
                this._state[key] = this._wrapWritable(key, data[key]);
            }
        }
    }
    getState() {
        return this._values;
    }
    getReactive() {
        return this._state;
    }
    _wrapWritable(key, val) {
        const wr = this._writable(val, key);
        wr.subscribe(v => {
            this._values[key] = v;
        });
        return wr;
    }
}
//# sourceMappingURL=Store.js.map